export default "__VITE_ASSET__ba8c187d__"